export namespace TunnelSanteCancelActionModels {
  /** Documents  */
  export enum CancelActionTypeEnum {
    CancelActivation = 1,
    CancelTempo = 2,
    CancelResil = 3,
    CancelLastAvenant = 4,
    CancelCaducite = 5,
    CancelLastRiskUpdate = 6,
  }
}
